/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// @ts-nocheck
import { css } from 'lit';
import { customElement } from 'lit/decorators.js';

import { styles } from '@material/web/tabs/internal/tabs-styles.js';
import { Tabs } from './internal/tabs.js';

// TODO(b/267336507): add docs
/**
 * @summary Tabs displays a list of selectable tabs.
 *
 */
@customElement('md-tabs')
export class MdTabs extends Tabs {
  static override styles = [
    styles,
    css`
      .tabs.no-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `,
  ];
}

declare global {
  interface HTMLElementTagNameMap {
    'md-tabs': MdTabs;
  }
}
